// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root.is-loading[data-v-6a77a040]{min-height:250px}.mcp-admin-merchant-details-section[data-v-6a77a040]{border-bottom:1px solid #d1d1d1}.field[data-v-6a77a040]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:18px}.label[data-v-6a77a040]{width:145px;font-weight:500;text-transform:uppercase;font-size:11px}.mcp-admin-merchant-details-section__header[data-v-6a77a040] div.v-application--wrap{margin-top:0;min-height:auto}", ""]);
// Exports
module.exports = exports;
